/**
 * Message part router component
 */

'use client';

import { TextMessagePart } from './TextMessagePart';
import { SearchHospitalsTool } from './SearchHospitalsTool';
import { HospitalDetailTool } from './HospitalDetailTool';
import type {
  MessagePartProps,
  TextPart,
  SearchHospitalsToolPart,
  HospitalDetailToolPart,
} from './types';

export function MessagePart({
  part,
  index,
  messageId,
  mode,
  role,
}: MessagePartProps) {
  const typedPart = part as { type: string };
  const { type } = typedPart;
  const key = `message-${messageId}-part-${index}`;

  // Text content
  if (type === 'text') {
    return (
      <TextMessagePart
        key={key}
        part={part as TextPart}
        mode={mode}
        role={role}
      />
    );
  }

  // Tool: searchHospitals
  if (type === 'tool-searchHospitals') {
    return (
      <SearchHospitalsTool
        key={key}
        part={part as SearchHospitalsToolPart}
      />
    );
  }

  // Tool: getHospitalDetail
  if (type === 'tool-getHospitalDetail') {
    return (
      <HospitalDetailTool
        key={key}
        part={part as HospitalDetailToolPart}
      />
    );
  }

  return null;
}
